module.exports = __webpack_public_path__ + "static/media/stock-findar.03f6a4d0.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/stock-findar.PNG
// module id = 86
// module chunks = 0